import MaterialTable from '@material-table/core';
import React, { Component } from 'react';
import mainStore from '../../../MainStore';
import LinearProgress from '@mui/material/LinearProgress';
import SchedulleStore from '../Scheduller/SchedulleStore';
//import './time.css';
//import { parse } from 'path';

export default class SaleTimeTab extends Component {
    timeColumns = [
        {
            title: 'Дата', field: 'dateStr', 'customSort': (a, b) => new Date(a.date) - new Date(b.date), defaultSort: 'desc'
        },
        { title: 'Пользователь', field: 'userName' },
        { title: 'Время', field: 'time' },
        { title: 'Комментарий', field: 'comment' },
        
    ];

    constructor(props) {
        super(props);
        this.state = {
            times: [],
            users: []
        };

        this.handleScheduleEdit = this.handleScheduleEdit.bind(this);
    }

    minutesToTimeStr(minutes) {
        var result = "";
        var hours = Math.floor(minutes / 60);
        if (hours !== 0) {
            result += hours + "ч "
        }

        minutes = minutes % 60;

        if (minutes > 10 || (minutes > 0 && hours === 0)) {
            result += minutes + "м"
        }
        else if (minutes > 0) {
            result += "0" + minutes + "м"
        }

        return result;
    }

    handleScheduleEdit(time) {
        time.saleId = this.props.saleId;
        SchedulleStore.openSaleSchedulleEditDialog(time, this.minutesToTimeStr(time.minutes));
    }

    componentWillMount() {
        if (!this.props.saleId) return;
        let scope = this;
        var token = localStorage.getItem("token");
        mainStore.setMaskVisible();
        fetch('api/Sale/GetTimeLog?saleId=' + this.props.saleId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    mainStore.setMaskUnvisible();
                    scope.setState({ times: result.times, users: result.users });
                }).catch((err) => console.log(err));
            }
        });
    }

    render() {
        var totalMinutes = this.state.users.reduce((a, b) => { return a + b.minutes; }, 0);
        return (
            <div className="full-width">
                {this.state.users.map(u => <div>
                    {u.name} 
                    <LinearProgress color="primary" variant="determinate" value={100 * u.minutes / totalMinutes} />
                    {u.time}
                </div>)}
                <MaterialTable
                    title=""
                    columns={this.timeColumns}

                    data={this.state.times}
                    editable={{
                    }}
                    actions={[
                        {
                            icon: 'edit',
                            tooltip: 'Редактировать',
                            isFreeAction: false,
                            onClick: (event, rowData) => {
                                this.handleScheduleEdit(rowData);
                            }
                        },
                    ]}
                />
            </div>
        );
    }
}
